import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IconSize } from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'med-upload-panel',
    templateUrl: './upload-panel.component.html',
    styleUrls: ['./upload-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadPanelComponent {
    iconSize: IconSize = IconSize.SMALL;

    @Input() buttonText: string;
    @Input() buttonIcon: string;
    @Input() title: string;
    @Input() message?: string;
    @Input() imageSrc: string;
    @Input() imageAlt: string;
    @Input() multiple?: boolean = true;
    @Input() disabled?: boolean = false;
    @Input() enableFileUpload: boolean = true;

    @Output() filesChanged: EventEmitter<FileList> = new EventEmitter<FileList>();
    @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();

    public fileInputChange(event: Event): void {
        const fileList: FileList = (event.target as HTMLInputElement).files as FileList;
        if (fileList) {
            this.filesChanged.emit(fileList);
        }
    }

    public onButtonClicked(): boolean {
        this.buttonClicked.emit();
        return false; // Suppress the opening of the file explorer
    }
}
